import { css, cx } from '@fable/theme'

export const GoalCompleteStarGroupRight = () => {
  return (
    <svg
      className={cx(
        'anim__goal-complete-star-group',
        css`
          width: 8px;
          position: absolute;
          right: 25%;
          bottom: 40%;
          transform: scale(0);
        `
      )}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 7.18 10.53"
    >
      <path
        d="m4.93,7.07c-.93-.05-1.66-.78-1.61-1.64,0-.19.02-.39.03-.59,0-.23-.15-.46-.4-.51-.32-.06-.6.15-.61.43,0,.21-.02.41-.03.62-.04.86-.83,1.52-1.75,1.49-.22,0-.44.1-.52.3-.12.31.13.61.45.63.01,0,.02,0,.03,0,.93.03,1.65.76,1.62,1.62,0,.19-.02.39-.03.59,0,.23.15.45.39.5.3.06.59-.15.6-.43,0-.21.02-.41.03-.62.04-.86.83-1.52,1.76-1.47.01,0,.02,0,.03,0,.32.02.6-.26.51-.58-.06-.2-.27-.33-.49-.34h0Z"
        fill="#f1c94e"
      />
      <path
        d="m6.85,1.8c-.61-.03-1.08-.51-1.06-1.08,0-.13.01-.25.02-.38,0-.15-.1-.3-.26-.33-.2-.04-.39.1-.4.28,0,.14,0,.27-.02.41-.03.56-.54,1-1.15.98-.15,0-.29.07-.34.19-.08.2.08.41.3.41,0,0,.01,0,.02,0,.61.02,1.08.5,1.06,1.07,0,.13-.01.26-.02.38,0,.15.1.3.26.33.2.04.38-.1.39-.28l.02-.41c.03-.56.54-1,1.15-.97,0,0,.01,0,.02,0,.22.01.39-.17.33-.38-.03-.13-.18-.22-.32-.22h0Z"
        fill="#f1c94e"
      />
    </svg>
  )
}
